import { useContext, useEffect, useState, useCallback } from "react";
import { toast } from "react-hot-toast";
import { GlobalContext } from "../../../../Context/GlobalContext";

/** tiny format helpers kept local */
const fmt = {
  dash: (v) => (v === null || v === undefined || v === "" ? "—" : v),
};

export default function useDining() {
  const { api, api2, baseUrl, adminId, latitude, longitude } =
    useContext(GlobalContext);

  const [clients, setClients] = useState([]);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [busy, setBusy] = useState({});

  const setSpin = (id, action) => setBusy((p) => ({ ...p, [id]: action }));
  const clearSpin = (id) => setBusy((p) => ({ ...p, [id]: null }));

  const getRestaurantTables = async (userid) => {
  try {
    const res = await api.post(
      "/Order/getRestaurantTable",
      { userid }
    );

    if (res?.data?.responseCode === "00") {
      return {
        success: true,
        data: res.data.response || [],
      };
    } else {
      return {
        success: false,
        message:
          res?.data?.responseMessage ||
          "Failed to fetch tables",
        data: [],
      };
    }
  } catch (e) {
    console.error("getRestaurantTable error:", e);
    return {
      success: false,
      message: "Error fetching tables",
      data: [],
    };
  }
};
const addRestaurantTable = async ({
  userid,
  tableNo,
}) => {
  try {
    const res = await api.post(
      "/Order/addRestaurantTable",
      { userid, tableNo }
    );

    if (res?.data?.responseCode === "00") {
      return {
        success: true,
        message:
          res?.data?.responseMessage ||
          "Table added",
      };
    } else {
      return {
        success: false,
        message:
          res?.data?.responseMessage ||
          "Failed to add table",
      };
    }
  } catch (e) {
    console.error("addRestaurantTable error:", e);
    return {
      success: false,
      message: "Error adding table",
    };
  }
};
const deleteDiningTable = async ({
  userid,
  tableNo,
}) => {
  try {
    const res = await api.post(
      "/Order/v1.0/deleteDiningTable",
      { userid, tableNo }
    );

    if (res?.data?.responseCode === "00") {
      return {
        success: true,
        message:
          res?.data?.responseMessage ||
          "Table deleted",
      };
    } else {
      return {
        success: false,
        message:
          res?.data?.responseMessage ||
          "Failed to delete table",
      };
    }
  } catch (e) {
    console.error("deleteDiningTable error:", e);
    return {
      success: false,
      message: "Error deleting table",
    };
  }
};
const getSpecialOffers = async (userid) => {
  try {
    const res = await api.post(
      "/Offer/v1.0/getSpecialOffer",
      { userid }
    );

    if (res?.data?.responseCode === "00") {
      return {
        success: true,
        data: res?.data?.response || [],
      };
    } else {
      return {
        success: false,
        message:
          res?.data?.responseMessage ||
          "Failed to fetch offers",
        data: [],
      };
    }
  } catch (e) {
    console.error("getSpecialOffer error:", e);
    return {
      success: false,
      message: "Error fetching offers",
      data: [],
    };
  }
};

const insertSpecialOffer = async ({
  userid,
  offerTitle,
  offerType,
}) => {
  try {
    const res = await api.post(
      "/Offer/v1.0/insertSpecialOffer",
      { userid, offerTitle, offerType }
    );

    if (res?.data?.responseCode === "00") {
      return {
        success: true,
        message:
          res?.data?.responseMessage ||
          "Offer added",
      };
    } else {
      return {
        success: false,
        message:
          res?.data?.responseMessage ||
          "Failed to add offer",
      };
    }
  } catch (e) {
    console.error("insertSpecialOffer error:", e);
    return {
      success: false,
      message: "Error adding offer",
    };
  }
};
const deleteSpecialOffer = async (id) => {
  try {
    const res = await api.post(
      "/Offer/v1.0/deleteSpecialOffer",
      { id: String(id) }
    );

    if (res?.data?.responseCode === "00") {
      return {
        success: true,
        message:
          res?.data?.responseMessage ||
          "Offer deleted",
      };
    } else {
      return {
        success: false,
        message:
          res?.data?.responseMessage ||
          "Failed to delete offer",
      };
    }
  } catch (e) {
    console.error("deleteSpecialOffer error:", e);
    return {
      success: false,
      message: "Error deleting offer",
    };
  }
};



  return {
    clients,
    orders,
    loading,
    busy,
  getRestaurantTables,
addRestaurantTable,
deleteDiningTable,
getSpecialOffers, 
insertSpecialOffer,
deleteSpecialOffer, 

  };
}